/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SystemVarsRestService, XeroSyncRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { combineLatest$ } from '@gh/rx/index';
import { map$, switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { XeroSyncDetails, xeroSyncDetailsFromDto, xeroSyncDetailsToDto, XeroSyncStatus } from './xero-sync.model';

@Injectable()
export class XeroSyncBusinessService implements InitViewService {
  constructor(private xeroRest: XeroSyncRestService) {

  }

  initView(): any {
    return {
      details: this.get(),
    };
  }

  get(): Observable<XeroSyncDetails> {
    return combineLatest$(this.xeroRest.getInfo(), this.getSyncStatus())
      .pipe(map$(([xero, status]) => xeroSyncDetailsFromDto(xero, status)));
  }

  getSyncStatus(): Observable<XeroSyncStatus> {
    return this.xeroRest.getSyncStatus();
  }

  startSync(details: XeroSyncDetails): Observable<XeroSyncStatus> {
    return this.xeroRest.sync(xeroSyncDetailsToDto(details))
      .pipe(switchMap$(() => this.getSyncStatus()));
  }
}
